export default {
    topics: [
        {
            title: ' CalculateExpectedValidationDate ',
            href: 'sm-operation-CalculateExpectedValidationDate.html',
            attributes: { 'data-id': 'sm-operation-CalculateExpectedValidationDate' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-CalculateExpectedValidationDate-d66e3414',
            topics: [],
        },
        {
            title: ' CalculateNextReminderDate ',
            href: 'sm-operation-CalculateNextReminderDate.html',
            attributes: { 'data-id': 'sm-operation-CalculateNextReminderDate' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-CalculateNextReminderDate-d66e3422',
            topics: [],
        },
        {
            title: ' Cancel ',
            href: 'sm-operation-Cancel.html',
            attributes: { 'data-id': 'sm-operation-Cancel' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-Cancel-d66e3430',
            topics: [],
        },
        {
            title: ' CheckValidationAccess ',
            href: 'sm-operation-CheckValidationAccess.html',
            attributes: { 'data-id': 'sm-operation-CheckValidationAccess' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-CheckValidationAccess-d66e3438',
            topics: [],
        },
        {
            title: ' CompleteDeliveryOperation ',
            href: 'sm-operation-CompleteDeliveryOperation.html',
            attributes: { 'data-id': 'sm-operation-CompleteDeliveryOperation' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-CompleteDeliveryOperation-d66e3446',
            topics: [],
        },
        {
            title: ' CompleteOperationPlanning ',
            href: 'sm-operation-CompleteOperationPlanning.html',
            attributes: { 'data-id': 'sm-operation-CompleteOperationPlanning' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-CompleteOperationPlanning-d66e3454',
            topics: [],
        },
        {
            title: ' CompleteTaskOperation ',
            href: 'sm-operation-CompleteTaskOperation.html',
            attributes: { 'data-id': 'sm-operation-CompleteTaskOperation' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-CompleteTaskOperation-d66e3462',
            topics: [],
        },
        {
            title: ' CreateOperationFromModel ',
            href: 'sm-operation-CreateOperationFromModel.html',
            attributes: { 'data-id': 'sm-operation-CreateOperationFromModel' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-CreateOperationFromModel-d66e3470',
            topics: [],
        },
        {
            title: ' CreateOperationFromModelId ',
            href: 'sm-operation-CreateOperationFromModelId.html',
            attributes: { 'data-id': 'sm-operation-CreateOperationFromModelId' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-CreateOperationFromModelId-d66e3478',
            topics: [],
        },
        {
            title: ' CreateWorkflowFromModelId ',
            href: 'sm-operation-CreateWorkflowFromModelId.html',
            attributes: { 'data-id': 'sm-operation-CreateWorkflowFromModelId' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-CreateWorkflowFromModelId-d66e3486',
            topics: [],
        },
        {
            title: ' DeliveryValidation ',
            href: 'sm-operation-DeliveryValidation.html',
            attributes: { 'data-id': 'sm-operation-DeliveryValidation' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-DeliveryValidation-d66e3495',
            topics: [],
        },
        {
            title: ' GetDeliveryCustomizationAsModel ',
            href: 'sm-operation-GetDeliveryCustomizationAsModel.html',
            attributes: { 'data-id': 'sm-operation-GetDeliveryCustomizationAsModel' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-GetDeliveryCustomizationAsModel-d66e3503',
            topics: [],
        },
        {
            title: ' NotifyReminder ',
            href: 'sm-operation-NotifyReminder.html',
            attributes: { 'data-id': 'sm-operation-NotifyReminder' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-NotifyReminder-d66e3511',
            topics: [],
        },
        {
            title: ' NotifyValidation ',
            href: 'sm-operation-NotifyValidation.html',
            attributes: { 'data-id': 'sm-operation-NotifyValidation' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-NotifyValidation-d66e3519',
            topics: [],
        },
        {
            title: ' PostUserOperationProcess ',
            href: 'sm-operation-PostUserOperationProcess.html',
            attributes: { 'data-id': 'sm-operation-PostUserOperationProcess' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-PostUserOperationProcess-d66e3527',
            topics: [],
        },
        {
            title: ' PreviewDelivery ',
            href: 'sm-operation-PreviewDelivery.html',
            attributes: { 'data-id': 'sm-operation-PreviewDelivery' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-PreviewDelivery-d66e3535',
            topics: [],
        },
        {
            title: ' StartDelivery ',
            href: 'sm-operation-StartDelivery.html',
            attributes: { 'data-id': 'sm-operation-StartDelivery' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-StartDelivery-d66e3543',
            topics: [],
        },
        {
            title: ' StartWorkflow ',
            href: 'sm-operation-StartWorkflow.html',
            attributes: { 'data-id': 'sm-operation-StartWorkflow' },
            menu: { hasChildren: false },
            tocID: 'sm-operation-StartWorkflow-d66e3551',
            topics: [],
        },
    ],
};

